import { render, staticRenderFns } from "./RecyclableBoxMaterial.vue?vue&type=template&id=0617430a&scoped=true&"
import script from "./RecyclableBoxMaterial.vue?vue&type=script&lang=js&"
export * from "./RecyclableBoxMaterial.vue?vue&type=script&lang=js&"
import style0 from "./RecyclableBoxMaterial.vue?vue&type=style&index=0&id=0617430a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0617430a",
  null
  
)

export default component.exports